import React from "react";
import FilesManager from "@/components/files/FilesManager";

export default function Files() {
  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-10 py-8" data-testid="files-page">
      <FilesManager />
    </div>
  );
}
